import trackPurchase from './trackPurchase'

export const analyticsService = {
  trackPurchase,
}

export default analyticsService
